module.exports = __webpack_public_path__ + "static/media/wb-segunda-franja-english.ad489cf3.svg";